import React, { useRef } from 'react';
import axios from 'axios';
import { Icon, TooltipHost, Spinner, SpinnerSize } from '@fluentui/react';
import Api from '../../../services/Api';
import { useState } from 'react';

const EditAppPermission = ({appPermission, siteId, refresh, setMessage, setIsEditing}) => {
    const cancelToken = axios.CancelToken;

    const cancelSource = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const updateAppPermission = () => {
        setIsLoading(true);
        setMessage();

        if (cancelSource.current) {
            cancelSource.current.cancel();
        }
        
        cancelSource.current = cancelToken.source();

        const post = {
            updateAppPermission: appPermission,
            id: siteId
        }

        let url = `/AdminUpdateSiteRequest`;

        Api.post(url, post, { cancelToken: cancelSource.current.token})
        .then(res => res.data)
        .then(c => {
            setIsLoading(false);
            refresh(siteId);
        })
        .catch(error => {
            setIsLoading(false);
            console.log(error);
            setMessage(error.response.data.message, true);
        });

        return () => {
            cancelSource.current.cancel();
        }
    }

    return (
        <div>
            {
                isLoading 
                ? <Spinner size={SpinnerSize.medium} styles={actionStyles} />
                : appPermission.isActive && appPermission.isEditing 
                    ? (
                        appPermission.permission !== appPermission.oldPermission && 
                        <TooltipHost content="Update Permission" styles={actionStyles} >
                            <Icon style={iconStyles} iconName="Accept" onClick={updateAppPermission} />
                        </TooltipHost>
                      )
                    : (
                        !appPermission.isLoading &&
                        <TooltipHost content="Edit Permission" styles={actionStyles} >
                        <   Icon style={iconStyles} iconName="Edit" onClick={() => setIsEditing(appPermission.id)} />
                        </TooltipHost>
                      )
            }
        </div>
    );
}

const actionStyles = {
    root: {
        margin: 'auto'
    }
}

const iconStyles = {
    cursor: 'pointer',
    margin: '0 5px',
    fontSize: '16px',
    fontWeight: '600'
}

export default EditAppPermission;


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/EditAppPermission.js